import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cohort, Site } from "../../models";

export interface DialogData {
  financials: any;
  cohort: Cohort;
  site: Site;
}

export interface PaymentRow {
  description: string;
  accrualPeriod: string;
  accrualDescription?: string;
  generation: string;
  generationDescription?: string;
  ppt?: number;
  pptDescription?: string;
  paymentAmount?: number;
  totalPayments?: number;
  totalRevenue: number;
  isVariable?: boolean;
}

@Component({
  selector: 'fc-dialog-payment-details',
  templateUrl: './dialog-payment-details.component.html',
  styleUrls: ['./dialog-payment-details.component.scss'],
})
export class DialogPaymentDetailsComponent {
  destroyRef = inject(DestroyRef);
  financialData: any = null;
  displayedColumns: string[] = ['description', 'accrualPeriod', 'generation', 'ppt', 'paymentAmount', 'totalPayments', 'totalRevenue'];
  paymentDetails: PaymentRow[] = [];
  cohort: Cohort = null;
  site: Site = null;

  constructor(
    public dialogRef: MatDialogRef<DialogPaymentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.financialData = data.financials;
    this.cohort = data.cohort;
    this.site = data.site;
    // prorated period
    this.paymentDetails.push({
      description: 'First Prorated Payment',
      accrualPeriod: this.financialData['prorated']['accrual'],
      generation: this.financialData['prorated']['ERT'].toFixed(4),
      generationDescription: 'Lower based on enrollment date',
      ppt: this.financialData['prorated']['PPT'],
      paymentAmount: this.financialData['prorated']['payment'],
      totalPayments: this.financialData['prorated']['count'],
      totalRevenue: this.financialData['prorated']['total'],
    });
    // fixed periods
    if (this.cohort.initialFixedYears > 0) {
      this.paymentDetails.push({
        description: 'Fixed Rate Periods',
        accrualPeriod: this.financialData['fixed']['accrual'],
        generation: this.financialData['fixed']['ERT'].toFixed(4),
        generationDescription: 'Subject to verification',
        ppt: this.financialData['fixed']['PPT'],
        pptDescription: 'Fixed price',
        paymentAmount: this.financialData['fixed']['payment'],
        totalPayments: this.financialData['fixed']['count'],
        totalRevenue: this.financialData['fixed']['total'],
      });
    }
    // variable periods
    if (this.cohort.initialFixedYears < 20) {
      this.paymentDetails.push({
        description: 'Variable Rate Periods',
        accrualPeriod: this.financialData['variable']['accrual'],
        generation: this.financialData['variable']['ERT'].toFixed(4),
        generationDescription: 'Subject to verification',
        ppt: this.financialData['variable']['PPT'],
        pptDescription: 'Variable per market rate',
        paymentAmount: this.financialData['variable']['payment'],
        totalPayments: this.financialData['variable']['count'],
        totalRevenue: this.financialData['variable']['total'],
        isVariable: true,
      });
    }
    this.paymentDetails.push({
      description: 'Estimated Total',
      accrualPeriod: this.financialData['total']['accrual'],
      generation: this.financialData['total']['ERT'].toFixed(4),
      totalRevenue: this.financialData['total']['total'],
    });
  }

  onNoClick(): void {
    this.dialogRef.close({ email: null, hiddenCheck: null });
  }
}
